export enum SignupFlow {
  students = 'students',
  mentors = 'mentors',
  employee = 'employee',
  ambassador = 'ambassador',
  company_admins = 'company_admins',
  'school-coach' = 'school-coach',
}
